module.exports = __webpack_public_path__ + "static/media/cypher-push.c900df43.png";